export const StartChattingTooltipCopy = 'Want to chat about support? I`m here to help you find your way.';

export enum TooltipTypes {
  unreadMessage = 'unreadMessage',
  startChatting = 'startChatting',
}
